module.exports = __webpack_public_path__ + "static/media/logo_hedera.feb215e0.svg";